import { IEquipmentMaintenanceBlank, IEquipmentMaintenanceFile } from '../../../../equipment.types.ts'
import EmptyPlaceholder from '../../../../../../shared/Common/EmptyPlaceholder'
import AttachmentFile from '../../../../../../shared/Files/Attachment/AttachmentFile'
import config from '../../../../../../config.ts'
import useAccessToken from '../../../../../Auth/hooks/useAccessToken.ts'
import mediaPreviewService from '../../../../../../services/MediaPreviewService/mediaPreview.service.ts'

interface IProps {
  files: IEquipmentMaintenanceBlank['files']
}

const EquipmentMaintenanceSidePageFilesContent = (props: IProps) => {
  const token = useAccessToken()

  if (!props.files.length) {
    return <EmptyPlaceholder inscription="Не было прикреплено ни одного файла" />
  }

  const openMediaPreview = (attachment: IEquipmentMaintenanceFile) => {
    mediaPreviewService.requestMediaPreview(
      props.files.map((f) => ({
        ...f,
        url: config.API_URL + `/nsi/v1/equipment-maintenance/blanks/files/${f.id}?accessToken=${token}`,
      })),
      props.files.findIndex((a) => a.id === attachment.id)
    )
  }

  return (
    <div className="inline-flex-gap gap16" style={{ flexWrap: 'wrap' }}>
      {props.files.map((f) => (
        <AttachmentFile
          onClick={() => openMediaPreview(f)}
          metadata={{ size: f.size, created: f.createdAt }}
          key={f.id}
          name={f.fileName}
          url={config.API_URL + `/nsi/v1/equipment-maintenance/blanks/files/${f.id}?accessToken=${token}`}
          extension={f.dataType}
        />
      ))}
    </div>
  )
}

export default EquipmentMaintenanceSidePageFilesContent
